import { securityAuthenticationLogoutPostAsyncSlice } from './post';

export const {
	requestPostSecurityAuthenticationLogout,
	resetPostSecurityAuthenticationLogout
} = securityAuthenticationLogoutPostAsyncSlice.asyncActionCreators;
